module.exports = __webpack_public_path__ + "img/left-fan-blades_56x56.d3f7e9a8.png";